"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M12 6a6 6 0 100 12 6 6 0 000-12zm.034 8.932c-1.177 0-2.193-.629-2.193-1.952h.968c0 .84.726 1.065 1.282 1.065.694 0 1.057-.315 1.057-.734 0-.444-.444-.597-1.307-.92l-.13-.048c-1.064-.403-1.717-.734-1.717-1.653 0-.984.766-1.645 2.033-1.645 1.193 0 2.097.54 2.097 1.903h-.968c0-.758-.549-1.017-1.137-1.017-.645 0-1.049.29-1.049.686 0 .476.395.613 1.218.904l.113.04c1 .355 1.871.71 1.871 1.701 0 .952-.718 1.67-2.138 1.67z" }), "Seasons");
//# sourceMappingURL=Seasons.js.map